import React, { useEffect } from 'react';
import './detallerubro.css';
import { rubros } from '../../json/rubros';
import { useParams, Link } from 'react-router-dom';

const DetalleRubro = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { nombre } = useParams();
  const rubro = rubros.find((rubro) => rubro.nombre === nombre);

  if (!rubro) {
    return (
      <main className="detalle-rubro-page">
        <div className="container">
          <div className="detalle-rubro-empty">
            <h2>Rubro no encontrado</h2>
            <Link to="/Transparencia/Rubros">Regresar a Rubros</Link>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="detalle-rubro-page">
      <div className="container container_detalle_rubro">
        <section className="detalle-rubro-hero">
          <div className="detalle-rubro-hero-icon" aria-hidden="true">
            <span>✓</span>
          </div>

          <div className="detalle-rubro-hero-copy">
            <span className="detalle-rubro-kicker">Transparencia · Artículo 69</span>
            <h1>{rubro.nombre}</h1>
            <span className="detalle-rubro-title-line" />
            <p>
              Consulta y descarga la información pública disponible para este rubro.
              Puedes abrir cada formato en tabla o descargar su archivo XLSX.
            </p>
          </div>

          <Link className="detalle-rubro-back" to="/Transparencia/Rubros">
            <span aria-hidden="true">←</span>
            Volver a Rubros
          </Link>
        </section>

        <section className="detalle-rubro-content">
          <div className="detalle-rubro-section-header">
            <div>
              <h2>Información disponible</h2>
              <span className="detalle-rubro-section-line" />
            </div>

            <div className="detalle-rubro-count">
              {rubro.formatos.length} {rubro.formatos.length === 1 ? 'formato' : 'formatos'}
            </div>
          </div>

          <div className="detalle-rubro-grid">
            {rubro.formatos.map((formato, index) => {
              const urlXLSX = '/' + formato.xlsx;
              const urlHTML = '/' + formato.html;
              const enlaceXLSX = formato.xlsx_liga ? formato.xlsx_liga : urlXLSX;
              const enlaceHTML = formato.htm_liga ? formato.htm_liga : urlHTML;

              return (
                <article key={index} className="detalle-rubro-card">
                  <div className="detalle-rubro-card-top">
                    <div className="detalle-rubro-card-icon" aria-hidden="true">
                      <span>{String(index + 1).padStart(2, '0')}</span>
                    </div>

                    <div className="detalle-rubro-card-copy">
                      <span className="detalle-rubro-card-label">Formato disponible</span>
                      <h3>{formato.nombre}</h3>
                    </div>
                  </div>

                  <div className="detalle-rubro-actions">
                    <a
                      className="detalle-btn detalle-btn-xlsx"
                      href={enlaceXLSX}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="detalle-btn-icon" aria-hidden="true">↓</span>
                      Descargar XLSX
                    </a>

                    <a
                      className="detalle-btn detalle-btn-table"
                      href={enlaceHTML}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="detalle-btn-icon detalle-btn-grid" aria-hidden="true">
                        <i></i><i></i><i></i><i></i>
                      </span>
                      Ver Tabla
                    </a>
                  </div>
                </article>
              );
            })}
          </div>
        </section>
      </div>
    </main>
  );
};

export default DetalleRubro;
